import { View } from 'app/shared/collections/view';
import { IMSVisualiser } from 'app/views/visualiser';
import { InitialDefaultMapOptionsForAsset } from 'app/shared/map_options/InitialMapOptionsAsset';
import { NonAssetInitialDefaultMapOptionsSetter } from 'app/shared/map_options/InitialMapOptionsNonAsset';
import { ILocalStorageService } from 'angular-local-storage';

/**
 * This class will create us a different InitialDefaultMapOptionsSetter depending on whether we require extra validation
 * for certain map options (ie assetDisplayColor)
 */
export class InitialMapOptionsFactory {
    private _localStorageService: ILocalStorageService;
    constructor(localStorageService: ILocalStorageService) {
        this._localStorageService = localStorageService;
    }

    public create(
        view: View,
        panelKey: string,
        assetImsVisualisers: { [key: string]: IMSVisualiser } = null,
    ) {
        if (assetImsVisualisers) {
            return new InitialDefaultMapOptionsForAsset(
                this._localStorageService,
                view,
                panelKey,
                assetImsVisualisers,
            );
        } else {
            return new NonAssetInitialDefaultMapOptionsSetter(
                this._localStorageService,
                view,
                panelKey,
            );
        }
    }
}
